import { render, staticRenderFns } from "./courseQuestions.vue?vue&type=template&id=cbec65e0&scoped=true&"
import script from "./courseQuestions.vue?vue&type=script&lang=js&"
export * from "./courseQuestions.vue?vue&type=script&lang=js&"
import style0 from "./courseQuestions.vue?vue&type=style&index=0&id=cbec65e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbec65e0",
  null
  
)

export default component.exports